import { useState } from 'react';
import { ExpandMore } from '@material-ui/icons';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';
import { TitleDivider } from '../common/titleDivider';
import { TableHead } from '@material-ui/core';
import { Button } from '@roc/ui';
import { Add } from '@material-ui/icons';
import { observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core';
import { FeeItem } from './feeItem';
import { useBaseStore } from '@roc/feature-app-core';
import { FeeItemFixed } from './feeItemFixed';
import { isBridgeLoan } from '../../utils/utils';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

interface PointsAndFeesAccordionProps {
  store: IQuoteTypeStore;
}

const useStyles = makeStyles(() => ({
  noBorders: {
    border: 'none',
  },
  headerCell: {
    color: '#9b9ea3',
    fontWeight: 'bold',
  },
}));

export const PointsAndFeesAccordion = observer(
  ({ store }: PointsAndFeesAccordionProps) => {
    const [expanded, setExpanded] = useState(true);

    return (
      <Accordion
        expanded={expanded}
        onChange={(e, expanded) => setExpanded(expanded)}
        elevation={0}
      >
        <AccordionSummary
          expandIcon={<ExpandMore fontSize="large" />}
          aria-controls="point-fees-accordion"
        >
          <TitleDivider title="Points and Fees" />
        </AccordionSummary>
        <AccordionDetails>
          <PointsAndFeesComponent store={store} />
        </AccordionDetails>
      </Accordion>
    );
  }
);

export const PointsAndFeesComponent = observer(
  ({ store }: PointsAndFeesAccordionProps) => {
    const { loanEconomicsStore } = store;
    const { globalStore } = useBaseStore();
    const classes = useStyles();
    const lenderName = globalStore?.lenderInfo?.lenderTradeName || 'Lender';

    function handleDeleteFee(feeKey: string) {
      loanEconomicsStore.removeFee(feeKey);
    }
    return (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                style={{ width: '20%' }}
                className={classes.headerCell}
              >
                Fee Name
              </TableCell>
              <TableCell
                align="center"
                style={{ width: '20%' }}
                className={classes.headerCell}
              >
                {lenderName}
              </TableCell>
              <TableCell
                style={{ width: '20%' }}
                className={classes.headerCell}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <FeeItemFixed
              store={loanEconomicsStore.interestReserveFeeStore}
              feeName="Interest Reserve *"
              showTogglePercentage={false}
            />
            <FeeItemFixed
              store={loanEconomicsStore.thirdPartyCostsFeeStore}
              feeName="Title, Insurance & Other Costs *"
              showTogglePercentage={false}
            />
            <FeeItemFixed
              store={loanEconomicsStore.originationPointsFeeStore}
              feeName="Origination Points"
              showTogglePercentage={false}
            />
            {loanEconomicsStore.feeStores.map((feeStore, index) => (
              <FeeItem
                key={feeStore.key}
                store={feeStore}
                onDeleteFee={handleDeleteFee}
              />
            ))}
            <TableRow>
              <TableCell style={{ width: '20%' }} className={classes.noBorders}>
                <Button
                  size="medium"
                  variant="outlined"
                  color="primary"
                  startIcon={<Add />}
                  testId="add-fee"
                  fullWidth
                  onClick={() => loanEconomicsStore.addNewFee()}
                >
                  ADD FEE
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
);
